import { type QueryClient } from '@tanstack/react-query'
import { type Address, type AddressApiError } from '@/features/account/services/Addresses/types'
import { getUser } from '@/features/account/services/User/utils'
import { isErrorResponseType } from '@/features/shared/utils/dataFetching/utils'
import { isValidZip } from '@/features/shared/utils/validator'

export const getAddresses = (queryClient: QueryClient) => getUser(queryClient)?.customer_addresses

export const getAddress = (addressId: number, queryClient: QueryClient) =>
  getAddresses(queryClient)?.find((address) => address.id === addressId)

export const getAddressError = (...errors: unknown[]): AddressApiError | null => {
  return errors.find(isErrorResponseType<AddressApiError>)?.response.data.error ?? null
}

type GetIsDoorDropoffProps = {
  address: Address
  hasRestrictedItems: boolean
  isPickup: boolean
}
export function getIsDoorDropoff({
  address,
  hasRestrictedItems,
  isPickup,
}: GetIsDoorDropoffProps): boolean {
  // An order cannot be dropped off if it is a pickup order or it contains
  // restricted items because they require a signature.
  return (address.door_dropoff ?? true) && !hasRestrictedItems && !isPickup
}

export const getFiveDigitZipcode = (zip: string | string[] | undefined): string => {
  const value = Array.isArray(zip) ? zip[0] : zip
  if (!value || !isValidZip(value)) return ''
  return value.slice(0, 5)
}
